<template>

  <div class="site-form-element-wrapper" :id="uniqId">

    <div class="site-form-element">
      <div class="select-box">
        <div :class="{'select-box__current':true, 'js-custom-dropdown':true, 'has-error':!!errorMessage}" tabindex="1">
          <input type="radio" class="js-hidden-valuer site-form-valuer" :data-target="inputName" tabindex="-1">

          <input class="select-box__input js-hidden-valuer-trigger" type="radio" :id="`reset-${inputName}`" :name="inputName" value="" checked="checked" tabindex="-1" @change="onChange">
          <p class="select-box__input-text">1</p>

          <template v-for="key in Object.keys(values)">
            <input class="select-box__input js-hidden-valuer-trigger" type="radio" :id="`${inputName}-${key}`" :name="inputName" :value="key" tabindex="-1" @change="onChange">
            <p class="select-box__input-text" v-html="values[key]"></p>
          </template>

          <!--          <input class="select-box__input js-hidden-valuer-trigger" type="radio" id="8f14e" :name="inputName" value="7" tabindex="-1">-->
          <!--          <p class="select-box__input-text">65 лет Победы, 12</p>-->


          <svg class="select-box__icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 17L3 7.94786L3.9424 7L12 15.1043L20.0576 7L21 7.94786L12 17Z" fill="#5A5B5D"></path>
          </svg>
          <div class="custom-label">{{ label }}</div>
        </div>
        <ul class="select-box__list">
          <li style="display:none;">
            <label class="select-box__option" :for="`reset-${inputName}`">Выберите из списка</label>
          </li>
          <li v-for="key in Object.keys(values)">
            <label class="select-box__option" :for="`${inputName}-${key}`" v-html="values[key]"></label>
          </li>
        </ul>
      </div>
    </div>

    <div class="site-form-error" v-if="errorMessage">{{ errorMessage }}</div>
  </div>

</template>

<script>
import {CustomDropdown} from "../../../block/customDropdown";

export default {
  name: "dropdown",
  props: {
    prompt: {
      type: String,
      default: 'Выберите значение',
    },
    label: {
      type: String
    },
    name: {
      required: true,
      default: null,
      type: [String, null]
    },
    values: {
      type: Object,
      default: null
    }
  },
  inject: ['errors', 'formKey'],
  computed: {
    uniqId: function () {
      return `field-${this.name ?? this.customName}`;
    },
    inputName: function () {
      return `${this.formKey}[${this.name}]`;
    },
    errorMessage: function () {
      const errors = this.errors[this.name];
      return errors ? errors.join('') : null;
    }
  },
  methods: {
    onChange(event) {
      this.$emit('update:modelValue', event.target.value);
      this.errors[this.name] = null;
    },
  },
}
</script>